import React from 'react';

import { cn } from '@lyearn/style';
import { Stack } from '@lyearn/ui';

import SettingTab from './SettingTab';
import { SettingsTabType } from './types';

export interface SettingsTabsProps {
  selectedTab: string;
  onTabChange: (val: string) => void;
  direction?: 'col' | 'row';
  size?: 'medium' | 'large' | 'x-large' | 'xx-large';
  tabs: SettingsTabType[];
  className?: string;
}

function SettingsTabs(props: SettingsTabsProps) {
  const { selectedTab, onTabChange, direction = 'row', size = 'large', tabs, className } = props;

  return (
    <Stack
      className={cn('w-full', className)}
      direction={direction}
      spacing={direction === 'row' ? 'gap-x-12' : 'gap-y-12'}>
      {tabs.map((tab) => (
        <SettingTab
          key={tab.id}
          direction={direction}
          isSelected={tab.id === selectedTab}
          size={size}
          tab={tab}
          onChange={onTabChange}
        />
      ))}
    </Stack>
  );
}

export default React.memo(SettingsTabs);
